import { ONE_DAY } from "@src/constants/time";
import { disableImpersonate } from "@src/services/impersonate";
import { selectIsLoadingDisableImpersonate } from "@src/store/slices/impersonate/selectors";
import { selectAuthUser } from "@src/store/slices/login/selectors";
import { User } from "@src/store/slices/login/types";
import { toast } from "@src/utils/toast";
import { useRouter } from "next/router";
import { useState } from "react";

import ConfirmModal from "../ConfirmModal";
import UserInfoBox from "./components/UserInfoBox";

import { useCookies } from "@src/hooks/useCookies";
import { useViewMode } from "@src/hooks/useViewMode";
import { useAppDispatch, useAppSelector } from "@src/store/hooks";

export default function ViewMode() {
  const dispatch = useAppDispatch();
  const user: User = useAppSelector(selectAuthUser) || ({ name: "", email: "", roles: [] } as User);
  const isLoadingDisableImpersonate = useAppSelector(selectIsLoadingDisableImpersonate);
  const isViewMode = useViewMode();
  const router = useRouter();
  const cookies = useCookies();

  const [disableModeView, setDisableModeView] = useState(false);

  if (isViewMode == false) {
    return;
  }

  const handleCancelDisable = () => {
    setDisableModeView(false);
  };

  const handleConfirmDisable = () => {
    setDisableModeView(true);
  };

  const handleLougoutImpersonate = async (): Promise<void> => {
    try {
      await dispatch(disableImpersonate()).then(response => {
        toast({
          type: "success",
          title: "Visualização encerrada",
          message: "Você retornou a sua visualização original.",
        });

        cookies.set(
          (process.env.NEXT_PUBLIC_PLATAFORM_NAME + "-Access-Token") as string,
          response.originalToken,
          ONE_DAY,
          {
            secure: true,
            sameSite: "Strict",
            path: "/",
          },
        );
      });
    } catch (error) {
      toast({
        type: "error",
        title: "Ocorreu um erro!",
        message: "Tente novamente mais tarde.",
      });
    } finally {
      setDisableModeView(false);

      const lastPage = localStorage.getItem("originalUserPagePath");
      router.push(lastPage || "/home", undefined, { scroll: true, shallow: false }).then(() => {
        window.location.reload();
      });
    }
  };

  return (
    <>
      <div className={`fixed z-[50] top-0 left-0 w-full border-4 border-afya-red-100`}></div>
      <div className={`fixed z-[50] top-0 left-0 w-2 h-full border-4 border-afya-red-100`}></div>
      <div className={`fixed z-[50] top-0 right-0 w-2 h-full border-4 border-afya-red-100`}></div>

      <div className="fixed bottom-0 left-0 w-full border-4 border-afya-red-100"></div>
      <UserInfoBox name={user.name} email={user.email} onConfirmDisable={handleConfirmDisable} />
      {disableModeView && (
        <ConfirmModal
          type="warning"
          isOpen={disableModeView}
          onClose={handleCancelDisable}
          onCancel={handleCancelDisable}
          onConfirm={handleLougoutImpersonate}
          title="Encerrar visualização"
          description={
            <p>
              Você está prestes a encerrar a visualização como <b>{user.name}</b>. <br />
              Deseja retornar à sua visualização original?
            </p>
          }
          confirmText="Continuar"
          cancelText="Cancelar"
          width="w-[480px]"
          isLoading={isLoadingDisableImpersonate}
        />
      )}
    </>
  );
}
